import React, { useContext, useEffect, useState } from 'react';
import { Alert, Container, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import FiltroEnProgreso from './FiltroEnProgreso';
import { enProgresoSelector, fetchEnProgreso, fetchTiposConcurso } from '../gestionConcursoSlice';
import ListaEnProgreso from './ListaEnProgreso';
import NuevoConcurso from '../NuevoConcurso';
import { BackContext } from '../../../../components/Main';
//import { userSelector } from "appStore/commonSlice";
import { useCheckRoles } from '../../../hooks';
import { ROLES } from '../../../../const';

const SinPermisos = () => {
  return (
    <>
      <Container fluid>
        <h2 className="text-center">Gestión de concursos</h2>

        <br />
      </Container>
      <Container>
        <Alert variant="danger">No cuenta con los permisos para tramitar.</Alert>
      </Container>
    </>
  );
};
const GestionConcursos = (props) => {
  const isLegales = useCheckRoles([ROLES.LEGALES]);
  const dispatch = useDispatch();
  const context = useContext(BackContext);
  const [showNuevo, setShowNuevo] = useState(false);

  const etapas = useSelector(enProgresoSelector);
  const [cantEnProgreso, setCantEnProgreso] = useState(0);
  //const user = useSelector(userSelector);

  const handleFiltrar = (values) => {
    const filtros = Object.keys(values).reduce(
      (acu, cur) => (values[cur] ? { ...acu, [cur]: values[cur] } : acu),
      {},
    );
    dispatch(fetchEnProgreso({ filtros }));
  };
  const handleNuevaConvocatoria = () => {
    setShowNuevo(true);
  };

  useEffect(() => {
    context.setBackTo('/');
    if (etapas.length <= 0) {
      dispatch(fetchTiposConcurso());
      dispatch(fetchEnProgreso());
    }
    setCantEnProgreso(etapas?.reduce((acum, cur) => acum + cur.llamadosConcurso.length, 0));
  }, [dispatch, etapas]);

  if (etapas.length > 0 && cantEnProgreso > 0) {
    return (
      <>
        <Container fluid>
          <h2 className="text-center">Gestión de concursos</h2>
          <Container>
            <FiltroEnProgreso onConfirm={(values) => handleFiltrar(values)} />
            <br></br>
            {isLegales && (
              <Button variant="success" onClick={handleNuevaConvocatoria}>
                <i className="fa fa-plus-circle"></i>&nbsp; Nueva Convocatoria
              </Button>
            )}
          </Container>
          <br />
        </Container>
        {etapas.map(
          (el) =>
            0 < el.llamadosConcurso.length && (
              <ListaEnProgreso
                key={el.idEtapaLlamadoConcurso}
                title={el.nombre}
                concursos={el.llamadosConcurso}
              />
            ),
        )}
        <NuevoConcurso size="lg" show={showNuevo} onCloseCallback={() => setShowNuevo(false)} />
      </>
    );
  } else if (etapas.length > 0 && cantEnProgreso === 0) {
    return (
      <>
        <Container fluid>
          <h2 className="text-center">Gestión de concursos</h2>
          <Container>
            <FiltroEnProgreso onConfirm={(values) => handleFiltrar(values)} />
            <br></br>
            {isLegales && (
              <Button variant="success" onClick={handleNuevaConvocatoria}>
                <i className="fa fa-plus-circle"></i>&nbsp; Nueva Convocatoria
              </Button>
            )}
          </Container>
          <br />
        </Container>
        <Container>
          <Alert variant="info">No se encuentran llamados a concurso pertinentes a su rol.</Alert>
        </Container>
        <NuevoConcurso size="lg" show={showNuevo} onCloseCallback={() => setShowNuevo(false)} />
      </>
    );
  } else if (typeof etapas.length === 'undefined' || etapas.length === 0) {
    return <SinPermisos />;
  } else {
    return <SinPermisos />;
  }
};

export default GestionConcursos;
